import DataTableInputSelect_vue_vue_type_script_setup_true_lang_default from "./DataTableInputSelect.vue.script.js";
//#region src/v2/components/data-table/DataTableInputSelect.vue
var DataTableInputSelect_default = DataTableInputSelect_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { DataTableInputSelect_default as default };

//# sourceMappingURL=DataTableInputSelect.vue.js.map